import { fetchApi } from '@/config/axiosSetting';
import {
  GetTakePhotoGuideVideoQueryParamsType,
  GetTakePhotoGuideVideoQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getTakePhotoGuideVideo/getTakePhotoGuideVideoQuery.type';

export const getTakePhotoGuideVideoFunction = (
  params: GetTakePhotoGuideVideoQueryParamsType,
): Promise<GetTakePhotoGuideVideoQueryResponseType> => {
  return fetchApi.get('defaults/photographing_guide_video/', { params });
};
